/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteStudentPlannedFocusDay$Params {
  profileId: string;
  id: string;
}

export function deleteStudentPlannedFocusDay(http: HttpClient, rootUrl: string, params: DeleteStudentPlannedFocusDay$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteStudentPlannedFocusDay.PATH, 'delete');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteStudentPlannedFocusDay.PATH = '/studentprofile/{profileId}/plannedfocusday/{id}';
